import { memo, useCallback, useMemo, useState } from "react";
import { Dropdown } from "antd";
import {
  DownOutlined,
  PlayCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const GuideMenu = ({
  id = "btn-guide",
  title,
  icon = <DownOutlined />,
  excludeMenu = [],
  onGuide = () => {},
  ...props
}) => {
  const { t } = useTranslation();

  const [isVisibleMenu, setIsVisibleMenu] = useState(false);

  const handleVisibleMenu = useCallback(() => {
    setIsVisibleMenu((prev) => !prev);
  }, []);

  const menuItems = useMemo(() => {
    const items = [
      {
        key: 1,
        icon: <PlayCircleOutlined />,
        onClick: (e) => {
          setTimeout(() => setIsVisibleMenu(false), 100);
          onGuide("video");
        },
        type: "video",
        label: t("button.video"),
      },
    ];
    return items.filter((row) => !excludeMenu.includes(row?.type));
  }, [onGuide, excludeMenu, t]);

  return (
    <div>
      <Dropdown.Button
        id={id}
        icon={icon}
        open={isVisibleMenu}
        trigger={["click"]}
        menu={{ items: menuItems, className: "p-0" }}
        overlayClassName="min-w-[135px]"
        onOpenChange={handleVisibleMenu}
        onClick={handleVisibleMenu}
        getPopupContainer={(trigger) => trigger.parentNode}
        {...props}
      >
        <div className="flex items-center justify-center">
          <QuestionCircleOutlined className="mr-2 mt-[2px]" size={16} />
          {title ? title : t("button.guide")}
        </div>
      </Dropdown.Button>
    </div>
  );
};

export default memo(GuideMenu);
